"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const base_api_service_1 = __importDefault(require("./base-api-service"));
class ApiService extends base_api_service_1.default {
    getAssets(params) {
        let endpoint = 'asset';
        return this.runGetQuery(endpoint, params);
    }
    getAsset(params) {
        let endpoint = 'asset';
        return this.runSingleGetQuery(endpoint, params.id);
    }
    createAsset(newAsset) {
        let endpoint = 'asset';
        let self = this;
        return this.runPostQuery(endpoint, newAsset.toServer(), false, null, false);
    }
    deleteAsset(assetId, item) {
        let endpoint = 'asset';
        return this.runDeleteQuery(endpoint, assetId, false);
    }
    updateAsset(assetId, updateObj, item) {
        let endpoint = 'asset';
        return this.runPutQuery(endpoint + '/' + assetId, updateObj, false);
    }
    getGateways(params) {
        let endpoint = 'gateway';
        return this.runGetQuery(endpoint, params);
    }
    getGateway(params) {
        let endpoint = 'gateway';
        return this.runSingleGetQuery(endpoint, params.id);
    }
    createGateway(newGateway) {
        let endpoint = 'gateway';
        let self = this;
        return this.runPostQuery(endpoint, newGateway.toServer(), false, null, false);
    }
    deleteGateway(gatewayId, item) {
        let endpoint = 'gateway';
        return this.runDeleteQuery(endpoint, gatewayId, false);
    }
    updateGateway(gatewayId, updateObj, item) {
        let endpoint = 'gateway';
        return this.runPutQuery(endpoint + '/' + gatewayId, updateObj, false);
    }
    getGatewaySoftwareVersions(params) {
        let endpoint = 'gateway-software-version';
        return this.runGetQuery(endpoint, params);
    }
    getGatewaySoftwareVersion(params) {
        let endpoint = 'gateway-software-version';
        return this.runSingleGetQuery(endpoint, params.id);
    }
    updateGatewaySoftwareVersion(gatewaySoftwareVersionId, updateObj, item) {
        let endpoint = 'gateway-software-version';
        return this.runPutQuery(endpoint + '/' + gatewaySoftwareVersionId, updateObj, false);
    }
    getSites(params) {
        let endpoint = 'site';
        return this.runGetQuery(endpoint, params);
    }
    getSite(params) {
        let endpoint = 'site';
        return this.runSingleGetQuery(endpoint, params.id);
    }
    createSite(newSite) {
        let endpoint = 'site';
        let self = this;
        return this.runPostQuery(endpoint, newSite.toServer(), false, null, false);
    }
    deleteSite(siteId, item) {
        let endpoint = 'site';
        return this.runDeleteQuery(endpoint, siteId, false);
    }
    updateSite(siteId, updateObj, item) {
        let endpoint = 'site';
        return this.runPutQuery(endpoint + '/' + siteId, updateObj, false);
    }
    getOrders(params) {
        let endpoint = 'order';
        return this.runGetQuery(endpoint, params);
    }
    createOrder(newOrder) {
        let endpoint = 'order';
        let self = this;
        return this.runPostQuery(endpoint, newOrder.toServer(), false, null, false);
    }
    getSessions(params) {
        let endpoint = 'session';
        return this.runGetQuery(endpoint, params);
    }
    getSession(params) {
        let endpoint = 'session';
        return this.runSingleGetQuery(endpoint, params.id);
    }
    createSession(newSession) {
        let endpoint = 'session';
        let self = this;
        return this.runPostQuery(endpoint, newSession.toServer(), false, null, false);
    }
    deleteSession(sessionId, item) {
        let endpoint = 'session';
        return this.runDeleteQuery(endpoint, sessionId, false);
    }
    updateSession(sessionId, updateObj, item) {
        let endpoint = 'session';
        return this.runPutQuery(endpoint + '/' + sessionId, updateObj, false);
    }
    getDiscounts(params) {
        let endpoint = 'discount';
        return this.runGetQuery(endpoint, params);
    }
    createStripeSession(newStripeSession) {
        let endpoint = 'stripe-session';
        let self = this;
        return this.runPostQuery(endpoint, newStripeSession.toServer(), false, null, false);
    }
    createStripeWebhook(newStripeWebhook) {
        let endpoint = 'stripe-webhook';
        let self = this;
        return this.runPostQuery(endpoint, newStripeWebhook.toServer(), false, null, true);
    }
    createZapierWebhook(newZapierWebhook) {
        let endpoint = 'zapier-webhook';
        let self = this;
        return this.runPostQuery(endpoint, newZapierWebhook.toServer(), false, null, true);
    }
    getPlacess(params) {
        let endpoint = 'places';
        return this.runGetQuery(endpoint, params, true);
    }
    getPlaces(params) {
        let endpoint = 'places';
        return this.runSingleGetQuery(endpoint, params.id, true);
    }
    getProducts(params) {
        let endpoint = 'product';
        return this.runGetQuery(endpoint, params);
    }
    getModbusModels(params) {
        let endpoint = 'modbus-model';
        return this.runGetQuery(endpoint, params);
    }
    getModbusModel(params) {
        let endpoint = 'modbus-model';
        return this.runSingleGetQuery(endpoint, params.id);
    }
    createModbusModel(newModbusModel) {
        let endpoint = 'modbus-model';
        let self = this;
        return this.runPostQuery(endpoint, newModbusModel.toServer(), false, null, false);
    }
    deleteModbusModel(modbusModelId, item) {
        let endpoint = 'modbus-model';
        return this.runDeleteQuery(endpoint, modbusModelId, false);
    }
    updateModbusModel(modbusModelId, updateObj, item) {
        let endpoint = 'modbus-model';
        return this.runPutQuery(endpoint + '/' + modbusModelId, updateObj, false);
    }
    getOccupancySchedules(params) {
        let endpoint = 'occupancy-schedule';
        return this.runGetQuery(endpoint, params);
    }
    getOccupancySchedule(params) {
        let endpoint = 'occupancy-schedule';
        return this.runSingleGetQuery(endpoint, params.id);
    }
    createOccupancySchedule(newOccupancySchedule) {
        let endpoint = 'occupancy-schedule';
        let self = this;
        return this.runPostQuery(endpoint, newOccupancySchedule.toServer(), false, null, false);
    }
    deleteOccupancySchedule(occupancyScheduleId, item) {
        let endpoint = 'occupancy-schedule';
        return this.runDeleteQuery(endpoint, occupancyScheduleId, false);
    }
    updateOccupancySchedule(occupancyScheduleId, updateObj, item) {
        let endpoint = 'occupancy-schedule';
        return this.runPutQuery(endpoint + '/' + occupancyScheduleId, updateObj, false);
    }
    createPubOrg(newPubOrg) {
        let endpoint = 'pub-org';
        let self = this;
        return this.runPostQuery(endpoint, newPubOrg.toServer(), false, null, false);
    }
    getOrganisation(params) {
        let endpoint = 'org';
        return this.runSingleGetQuery(endpoint, params.id);
    }
    updateOrganisation(organisationId, updateObj, item) {
        let endpoint = 'org';
        return this.runPutQuery(endpoint + '/' + organisationId, updateObj, false);
    }
    getPaymentCards(params) {
        let endpoint = 'payment-card';
        return this.runGetQuery(endpoint, params);
    }
    getPaymentCard(params) {
        let endpoint = 'payment-card';
        return this.runSingleGetQuery(endpoint, params.id);
    }
    createPaymentCard(newPaymentCard) {
        let endpoint = 'payment-card';
        let self = this;
        return this.runPostQuery(endpoint, newPaymentCard.toServer(), false, null, false);
    }
    deletePaymentCard(paymentCardId, item) {
        let endpoint = 'payment-card';
        return this.runDeleteQuery(endpoint, paymentCardId, false);
    }
    updatePaymentCard(paymentCardId, updateObj, item) {
        let endpoint = 'payment-card';
        return this.runPutQuery(endpoint + '/' + paymentCardId, updateObj, false);
    }
    getAssetEvents(params) {
        let assetIdFilter = params.filters.find(f => f.field === 'assetId');
        let startFilter = params.filters.find(f => f.field === 'start');
        let endFilter = params.filters.find(f => f.field === 'end');
        if (!assetIdFilter || !startFilter || !endFilter) {
            return Promise.reject('Missing required parameter in filters');
        }
        let endpoint = 'assetEvent/:assetId/:start/:end/';
        endpoint = endpoint.replace(':assetId', assetIdFilter.value + "");
        endpoint = endpoint.replace(':start', startFilter.value + "");
        endpoint = endpoint.replace(':end', endFilter.value + "");
        return this.runGetQuery(endpoint, params);
    }
    getGatewayEvents(params) {
        let gatewayIdFilter = params.filters.find(f => f.field === 'gatewayId');
        let startFilter = params.filters.find(f => f.field === 'start');
        let endFilter = params.filters.find(f => f.field === 'end');
        if (!gatewayIdFilter || !startFilter || !endFilter) {
            return Promise.reject('Missing required parameter in filters');
        }
        let endpoint = 'gatewayEvent/:gatewayId/:start/:end/';
        endpoint = endpoint.replace(':gatewayId', gatewayIdFilter.value + "");
        endpoint = endpoint.replace(':start', startFilter.value + "");
        endpoint = endpoint.replace(':end', endFilter.value + "");
        return this.runGetQuery(endpoint, params);
    }
    getAssetTelemetrys(params) {
        let dataTypeFilter = params.filters.find(f => f.field === 'dataType');
        let assetIdFilter = params.filters.find(f => f.field === 'assetId');
        let startFilter = params.filters.find(f => f.field === 'start');
        let endFilter = params.filters.find(f => f.field === 'end');
        if (!dataTypeFilter || !assetIdFilter || !startFilter || !endFilter) {
            return Promise.reject('Missing required parameter in filters');
        }
        let endpoint = 'assetTelemetry/:dataType/:assetId/:start/:end/';
        endpoint = endpoint.replace(':dataType', dataTypeFilter.value + "");
        endpoint = endpoint.replace(':assetId', assetIdFilter.value + "");
        endpoint = endpoint.replace(':start', startFilter.value + "");
        endpoint = endpoint.replace(':end', endFilter.value + "");
        return this.runGetQuery(endpoint, params);
    }
    getRules(params) {
        let endpoint = 'rule';
        return this.runGetQuery(endpoint, params);
    }
    getRule(params) {
        let endpoint = 'rule';
        return this.runSingleGetQuery(endpoint, params.id);
    }
    createRule(newRule) {
        let endpoint = 'rule';
        let self = this;
        return this.runPostQuery(endpoint, newRule.toServer(), false, null, false);
    }
    deleteRule(ruleId, item) {
        let endpoint = 'rule';
        return this.runDeleteQuery(endpoint, ruleId, false);
    }
    updateRule(ruleId, updateObj, item) {
        let endpoint = 'rule';
        return this.runPutQuery(endpoint + '/' + ruleId, updateObj, false);
    }
    getDataRequests(params) {
        let endpoint = 'data-request';
        return this.runGetQuery(endpoint, params);
    }
    getDataRequest(params) {
        let endpoint = 'data-request';
        return this.runSingleGetQuery(endpoint, params.id);
    }
    createDataRequest(newDataRequest) {
        let endpoint = 'data-request';
        let self = this;
        return this.runPostQuery(endpoint, newDataRequest.toServer(), false, null, false);
    }
    deleteDataRequest(dataRequestId, item) {
        let endpoint = 'data-request';
        return this.runDeleteQuery(endpoint, dataRequestId, false);
    }
    createDataRequestLink(newDataRequestLink) {
        let endpoint = 'data-request/:dataRequestId/link';
        let self = this;
        endpoint = endpoint.replace(':dataRequestId', (newDataRequestLink.dataRequestId ? newDataRequestLink.dataRequestId : '') + "");
        return this.runPostQuery(endpoint, newDataRequestLink.toServer(), false, null, false);
    }
    getInvoiceRequests(params) {
        let endpoint = 'invoice-request';
        return this.runGetQuery(endpoint, params);
    }
    getInvoiceRequest(params) {
        let endpoint = 'invoice-request';
        return this.runSingleGetQuery(endpoint, params.id);
    }
    createInvoiceRequest(newInvoiceRequest) {
        let endpoint = 'invoice-request';
        let self = this;
        return this.runPostQuery(endpoint, newInvoiceRequest.toServer(), false, null, false);
    }
    deleteInvoiceRequest(invoiceRequestId, item) {
        let endpoint = 'invoice-request';
        return this.runDeleteQuery(endpoint, invoiceRequestId, false);
    }
    createInvoiceRequestLink(newInvoiceRequestLink) {
        let endpoint = 'invoice-request/:invoiceRequestId/link';
        let self = this;
        endpoint = endpoint.replace(':invoiceRequestId', (newInvoiceRequestLink.invoiceRequestId ? newInvoiceRequestLink.invoiceRequestId : '') + "");
        return this.runPostQuery(endpoint, newInvoiceRequestLink.toServer(), false, null, false);
    }
    getSiteGroups(params) {
        let endpoint = 'site-group';
        return this.runGetQuery(endpoint, params);
    }
    getSiteGroup(params) {
        let endpoint = 'site-group';
        return this.runSingleGetQuery(endpoint, params.id);
    }
    createSiteGroup(newSiteGroup) {
        let endpoint = 'site-group';
        let self = this;
        return this.runPostQuery(endpoint, newSiteGroup.toServer(), false, null, false);
    }
    deleteSiteGroup(siteGroupId, item) {
        let endpoint = 'site-group';
        return this.runDeleteQuery(endpoint, siteGroupId, false);
    }
    updateSiteGroup(siteGroupId, updateObj, item) {
        let endpoint = 'site-group';
        return this.runPutQuery(endpoint + '/' + siteGroupId, updateObj, false);
    }
    getGroups(params) {
        let endpoint = 'group';
        return this.runGetQuery(endpoint, params);
    }
    getGroup(params) {
        let endpoint = 'group';
        return this.runSingleGetQuery(endpoint, params.id);
    }
    createGroup(newGroup) {
        let endpoint = 'group';
        let self = this;
        return this.runPostQuery(endpoint, newGroup.toServer(), false, null, false);
    }
    deleteGroup(groupId, item) {
        let endpoint = 'group';
        return this.runDeleteQuery(endpoint, groupId, false);
    }
    updateGroup(groupId, updateObj, item) {
        let endpoint = 'group';
        return this.runPutQuery(endpoint + '/' + groupId, updateObj, false);
    }
    getDuckChargeAdmins(params) {
        let endpoint = 'duck-charge-admin';
        return this.runGetQuery(endpoint, params);
    }
    getCustomFieldTypes(params) {
        let endpoint = 'custom-field-type';
        return this.runGetQuery(endpoint, params);
    }
    createCustomFieldType(newCustomFieldType) {
        let endpoint = 'custom-field-type';
        let self = this;
        return this.runPostQuery(endpoint, newCustomFieldType.toServer(), false, null, false);
    }
    deleteCustomFieldType(customFieldTypeId, item) {
        let endpoint = 'custom-field-type';
        return this.runDeleteQuery(endpoint, customFieldTypeId, false);
    }
    updateCustomFieldType(customFieldTypeId, updateObj, item) {
        let endpoint = 'custom-field-type';
        return this.runPutQuery(endpoint + '/' + customFieldTypeId, updateObj, false);
    }
    getCustomFields(params) {
        let endpoint = 'custom-field';
        return this.runGetQuery(endpoint, params);
    }
    createCustomField(newCustomField) {
        let endpoint = 'custom-field';
        let self = this;
        return this.runPostQuery(endpoint, newCustomField.toServer(), false, null, false);
    }
    deleteCustomField(customFieldId, item) {
        let endpoint = 'custom-field';
        return this.runDeleteQuery(endpoint, customFieldId, false);
    }
    updateCustomField(customFieldId, updateObj, item) {
        let endpoint = 'custom-field';
        return this.runPutQuery(endpoint + '/' + customFieldId, updateObj, false);
    }
    getLocations(params) {
        let endpoint = 'location';
        return this.runGetQuery(endpoint, params);
    }
    createLocation(newLocation) {
        let endpoint = 'location';
        let self = this;
        return this.runPostQuery(endpoint, newLocation.toServer(), false, null, false);
    }
    deleteLocation(locationId, item) {
        let endpoint = 'location';
        return this.runDeleteQuery(endpoint, locationId, false);
    }
    updateLocation(locationId, updateObj, item) {
        let endpoint = 'location';
        return this.runPutQuery(endpoint + '/' + locationId, updateObj, false);
    }
    getSearchHistorys(params) {
        let endpoint = 'search-history';
        return this.runGetQuery(endpoint, params);
    }
    createSearchHistory(newSearchHistory) {
        let endpoint = 'search-history';
        let self = this;
        return this.runPostQuery(endpoint, newSearchHistory.toServer(), false, null, false);
    }
    deleteSearchHistory(searchHistoryId, item) {
        let endpoint = 'search-history';
        return this.runDeleteQuery(endpoint, searchHistoryId, false);
    }
    getTariffs(params) {
        let endpoint = 'tariff';
        return this.runGetQuery(endpoint, params);
    }
    getTariff(params) {
        let endpoint = 'tariff';
        return this.runSingleGetQuery(endpoint, params.id);
    }
    createTariff(newTariff) {
        let endpoint = 'tariff';
        let self = this;
        return this.runPostQuery(endpoint, newTariff.toServer(), false, null, false);
    }
    deleteTariff(tariffId, item) {
        let endpoint = 'tariff';
        return this.runDeleteQuery(endpoint, tariffId, false);
    }
    updateTariff(tariffId, updateObj, item) {
        let endpoint = 'tariff';
        return this.runPutQuery(endpoint + '/' + tariffId, updateObj, false);
    }
    getGroupTypes(params) {
        let endpoint = 'group-type';
        return this.runGetQuery(endpoint, params);
    }
    createGroupType(newGroupType) {
        let endpoint = 'group-type';
        let self = this;
        return this.runPostQuery(endpoint, newGroupType.toServer(), false, null, false);
    }
    deleteGroupType(groupTypeId, item) {
        let endpoint = 'group-type';
        return this.runDeleteQuery(endpoint, groupTypeId, false);
    }
    updateGroupType(groupTypeId, updateObj, item) {
        let endpoint = 'group-type';
        return this.runPutQuery(endpoint + '/' + groupTypeId, updateObj, false);
    }
    createCalculatorInbound(newCalculatorInbound) {
        let endpoint = 'calculator-inbound';
        let self = this;
        return this.runPostQuery(endpoint, newCalculatorInbound.toServer(), false, null, true);
    }
    createCalculatorResult(newCalculatorResult) {
        let endpoint = 'calculator-result';
        let self = this;
        return this.runPostQuery(endpoint, newCalculatorResult.toServer(), false, null, true);
    }
    createCreateReport(newCreateReport) {
        let endpoint = 'create-report';
        let self = this;
        return this.runPostQuery(endpoint, newCreateReport.toServer(), false, null, true);
    }
    getReportHistorys(params) {
        let endpoint = 'report-history';
        return this.runGetQuery(endpoint, params);
    }
    getReports(params) {
        let endpoint = 'report';
        return this.runGetQuery(endpoint, params);
    }
    getReport(params) {
        let endpoint = 'report';
        return this.runSingleGetQuery(endpoint, params.id);
    }
    createReport(newReport) {
        let endpoint = 'report';
        let self = this;
        return this.runPostQuery(endpoint, newReport.toServer(), false, null, false);
    }
    deleteReport(reportId, item) {
        let endpoint = 'report';
        return this.runDeleteQuery(endpoint, reportId, false);
    }
    updateReport(reportId, updateObj, item) {
        let endpoint = 'report';
        return this.runPutQuery(endpoint + '/' + reportId, updateObj, false);
    }
    getReportFiles(params) {
        let endpoint = 'report-file';
        return this.runGetQuery(endpoint, params);
    }
    getGaiaConversations(params) {
        let endpoint = 'gaia-conversation';
        return this.runGetQuery(endpoint, params);
    }
    getGaiaConversation(params) {
        let endpoint = 'gaia-conversation';
        return this.runSingleGetQuery(endpoint, params.id);
    }
    deleteGaiaConversation(gaiaConversationId, item) {
        let endpoint = 'gaia-conversation';
        return this.runDeleteQuery(endpoint, gaiaConversationId, false);
    }
    updateGaiaConversation(gaiaConversationId, updateObj, item) {
        let endpoint = 'gaia-conversation';
        return this.runPutQuery(endpoint + '/' + gaiaConversationId, updateObj, false);
    }
    getGaiaMessages(params) {
        let endpoint = 'gaia-message';
        return this.runGetQuery(endpoint, params);
    }
    createGaiaMessage(newGaiaMessage) {
        let endpoint = 'gaia-message';
        let self = this;
        return this.runPostQuery(endpoint, newGaiaMessage.toServer(), false, null, false);
    }
    getDataCategorys(params) {
        let endpoint = 'data-category';
        return this.runGetQuery(endpoint, params);
    }
    getDataCategory(params) {
        let endpoint = 'data-category';
        return this.runSingleGetQuery(endpoint, params.id);
    }
    createDataCategory(newDataCategory) {
        let endpoint = 'data-category';
        let self = this;
        return this.runPostQuery(endpoint, newDataCategory.toServer(), false, null, false);
    }
    deleteDataCategory(dataCategoryId, item) {
        let endpoint = 'data-category';
        return this.runDeleteQuery(endpoint, dataCategoryId, false);
    }
    updateDataCategory(dataCategoryId, updateObj, item) {
        let endpoint = 'data-category';
        return this.runPutQuery(endpoint + '/' + dataCategoryId, updateObj, false);
    }
    getDataTypes(params) {
        let endpoint = 'data-type';
        return this.runGetQuery(endpoint, params);
    }
    getDataType(params) {
        let endpoint = 'data-type';
        return this.runSingleGetQuery(endpoint, params.id);
    }
    createDataType(newDataType) {
        let endpoint = 'data-type';
        let self = this;
        return this.runPostQuery(endpoint, newDataType.toServer(), false, null, false);
    }
    deleteDataType(dataTypeId, item) {
        let endpoint = 'data-type';
        return this.runDeleteQuery(endpoint, dataTypeId, false);
    }
    updateDataType(dataTypeId, updateObj, item) {
        let endpoint = 'data-type';
        return this.runPutQuery(endpoint + '/' + dataTypeId, updateObj, false);
    }
    getDeviceCategorys(params) {
        let endpoint = 'device-category';
        return this.runGetQuery(endpoint, params);
    }
    createDeviceCategory(newDeviceCategory) {
        let endpoint = 'device-category';
        let self = this;
        return this.runPostQuery(endpoint, newDeviceCategory.toServer(), false, null, false);
    }
    deleteDeviceCategory(deviceCategoryId, item) {
        let endpoint = 'device-category';
        return this.runDeleteQuery(endpoint, deviceCategoryId, false);
    }
    updateDeviceCategory(deviceCategoryId, updateObj, item) {
        let endpoint = 'device-category';
        return this.runPutQuery(endpoint + '/' + deviceCategoryId, updateObj, false);
    }
    getWidgetBoard(params) {
        let endpoint = 'widget-board';
        return this.runSingleGetQuery(endpoint, params.id);
    }
    createWidgetBoard(newWidgetBoard) {
        let endpoint = 'widget-board';
        let self = this;
        return this.runPostQuery(endpoint, newWidgetBoard.toServer(), false, null, false);
    }
    updateWidgetBoard(widgetBoardId, updateObj, item) {
        let endpoint = 'widget-board';
        return this.runPutQuery(endpoint + '/' + widgetBoardId, updateObj, false);
    }
    createReportFileLink(newReportFileLink) {
        let endpoint = 'report-file/:fileId/link';
        let self = this;
        endpoint = endpoint.replace(':fileId', (newReportFileLink.fileId ? newReportFileLink.fileId : '') + "");
        return this.runPostQuery(endpoint, newReportFileLink.toServer(), false, null, false);
    }
    getRuleEvents(params) {
        let ruleIdFilter = params.filters.find(f => f.field === 'ruleId');
        let startFilter = params.filters.find(f => f.field === 'start');
        let endFilter = params.filters.find(f => f.field === 'end');
        if (!ruleIdFilter || !startFilter || !endFilter) {
            return Promise.reject('Missing required parameter in filters');
        }
        let endpoint = 'rule/:ruleId/event/:start/:end/';
        endpoint = endpoint.replace(':ruleId', ruleIdFilter.value + "");
        endpoint = endpoint.replace(':start', startFilter.value + "");
        endpoint = endpoint.replace(':end', endFilter.value + "");
        return this.runGetQuery(endpoint, params);
    }
    getAudits(params) {
        let endpoint = 'audit';
        return this.runGetQuery(endpoint, params);
    }
    getAudit(params) {
        let endpoint = 'audit';
        return this.runSingleGetQuery(endpoint, params.id);
    }
    createAudit(newAudit) {
        let endpoint = 'audit';
        let self = this;
        return this.runPostQuery(endpoint, newAudit.toServer(), false, null, false);
    }
    getApplications(params) {
        let endpoint = 'application';
        return this.runGetQuery(endpoint, params);
    }
    getApplication(params) {
        let endpoint = 'application';
        return this.runSingleGetQuery(endpoint, params.id);
    }
    createApplication(newApplication) {
        let endpoint = 'application';
        let self = this;
        return this.runPostQuery(endpoint, newApplication.toServer(), false, null, false);
    }
    deleteApplication(applicationId, item) {
        let endpoint = 'application';
        return this.runDeleteQuery(endpoint, applicationId, false);
    }
    getAnomalyModels(params) {
        let endpoint = 'anomaly-model';
        return this.runGetQuery(endpoint, params);
    }
    getAnomalyModel(params) {
        let endpoint = 'anomaly-model';
        return this.runSingleGetQuery(endpoint, params.id);
    }
    getAnomalys(params) {
        let endpoint = 'anomaly';
        return this.runGetQuery(endpoint, params);
    }
    getAnomaly(params) {
        let endpoint = 'anomaly';
        return this.runSingleGetQuery(endpoint, params.id);
    }
    updateAnomaly(anomalyId, updateObj, item) {
        let endpoint = 'anomaly';
        return this.runPutQuery(endpoint + '/' + anomalyId, updateObj, false);
    }
    getGridduckSubscriptions(params) {
        let endpoint = 'gridduck-subscription';
        return this.runGetQuery(endpoint, params);
    }
    getGridduckInvoices(params) {
        let endpoint = 'gridduck-invoice';
        return this.runGetQuery(endpoint, params);
    }
    getAccounts(params) {
        let endpoint = 'account';
        return this.runGetQuery(endpoint, params);
    }
    getAccount(params) {
        let endpoint = 'account';
        return this.runSingleGetQuery(endpoint, params.id);
    }
    updateAccount(accountId, updateObj, item) {
        let endpoint = 'account';
        return this.runPutQuery(endpoint + '/' + accountId, updateObj, false);
    }
    getCustomFieldDatas(params) {
        let endpoint = 'custom-field-data';
        return this.runGetQuery(endpoint, params);
    }
    getPreferences(params) {
        let endpoint = 'preferences';
        return this.runSingleGetQuery(endpoint, params.id);
    }
    updatePreferences(preferencesId, updateObj, item) {
        let endpoint = 'preferences';
        return this.runPutQuery(endpoint + '/' + preferencesId, updateObj, false);
    }
    createDcRetryPayment(newDcRetryPayment) {
        let endpoint = 'dc-retry-payment';
        let self = this;
        return this.runPostQuery(endpoint, newDcRetryPayment.toServer(), false, null, false);
    }
    getIssues(params) {
        let endpoint = 'issue';
        return this.runGetQuery(endpoint, params);
    }
    getIgnoredDevices(params) {
        let endpoint = 'ignored-device';
        return this.runGetQuery(endpoint, params);
    }
    createResetSecret(newResetSecret) {
        let endpoint = 'application/:applicationId/reset_secret';
        let self = this;
        endpoint = endpoint.replace(':applicationId', (newResetSecret.applicationId ? newResetSecret.applicationId : '') + "");
        return this.runPostQuery(endpoint, newResetSecret.toServer(), false, null, false);
    }
    createRequestSecret(newRequestSecret) {
        let endpoint = 'application/:applicationId/request_secret';
        let self = this;
        endpoint = endpoint.replace(':applicationId', (newRequestSecret.applicationId ? newRequestSecret.applicationId : '') + "");
        return this.runPostQuery(endpoint, newRequestSecret.toServer(), false, null, false);
    }
    createAssetIdentification(newAssetIdentification) {
        let endpoint = 'asset/:assetId/identification';
        let self = this;
        endpoint = endpoint.replace(':assetId', (newAssetIdentification.assetId ? newAssetIdentification.assetId : '') + "");
        return this.runPostQuery(endpoint, newAssetIdentification.toServer(), false, null, false);
    }
    createGetPhaseBreakdown(newGetPhaseBreakdown) {
        let endpoint = 'asset/:assetId/getPhaseBreakdown';
        let self = this;
        endpoint = endpoint.replace(':assetId', (newGetPhaseBreakdown.assetId ? newGetPhaseBreakdown.assetId : '') + "");
        return this.runPostQuery(endpoint, newGetPhaseBreakdown.toServer(), false, null, false);
    }
    getAvailableGateways(params) {
        let endpoint = 'availableGateway';
        return this.runGetQuery(endpoint, params);
    }
    updateAvailableGateway(availableGatewayId, updateObj, item) {
        let endpoint = 'availableGateway';
        return this.runPutQuery(endpoint + '/' + availableGatewayId, updateObj, false);
    }
    getAssetDemands(params) {
        let assetIdFilter = params.filters.find(f => f.field === 'assetId');
        let startFilter = params.filters.find(f => f.field === 'start');
        let endFilter = params.filters.find(f => f.field === 'end');
        if (!assetIdFilter || !startFilter || !endFilter) {
            return Promise.reject('Missing required parameter in filters');
        }
        let endpoint = 'telemetry/assetDemand/:assetId/:start/:end';
        endpoint = endpoint.replace(':assetId', assetIdFilter.value + "");
        endpoint = endpoint.replace(':start', startFilter.value + "");
        endpoint = endpoint.replace(':end', endFilter.value + "");
        return this.runGetQuery(endpoint, params);
    }
    getAssetConsumptions(params) {
        let assetIdFilter = params.filters.find(f => f.field === 'assetId');
        let startFilter = params.filters.find(f => f.field === 'start');
        let endFilter = params.filters.find(f => f.field === 'end');
        let granularityFilter = params.filters.find(f => f.field === 'granularity');
        let dataTypeFilter = params.filters.find(f => f.field === 'dataType');
        if (!assetIdFilter || !startFilter || !endFilter || !granularityFilter || !dataTypeFilter) {
            return Promise.reject('Missing required parameter in filters');
        }
        let endpoint = 'telemetry/assetConsumption/:assetId/:start/:end/:granularity';
        endpoint = endpoint.replace(':assetId', assetIdFilter.value + "");
        endpoint = endpoint.replace(':start', startFilter.value + "");
        endpoint = endpoint.replace(':end', endFilter.value + "");
        endpoint = endpoint.replace(':granularity', granularityFilter.value + "");
        endpoint = endpoint.replace(':dataType', dataTypeFilter.value + "");
        return this.runGetQuery(endpoint, params);
    }
    getPhysicalGateway(params) {
        let endpoint = 'physicalGateway';
        return this.runSingleGetQuery(endpoint, params.id);
    }
    createPhysicalGateway(newPhysicalGateway) {
        let endpoint = 'physicalGateway';
        let self = this;
        return this.runPostQuery(endpoint, newPhysicalGateway.toServer(), false, null, false);
    }
    updatePhysicalGateway(physicalGatewayId, updateObj, item) {
        let endpoint = 'physicalGateway';
        return this.runPutQuery(endpoint + '/' + physicalGatewayId, updateObj, false);
    }
    getSitePermissions(params) {
        let siteIdFilter = params.filters.find(f => f.field === 'siteId');
        if (!siteIdFilter) {
            return Promise.reject('Missing required parameter in filters');
        }
        let endpoint = 'site/:siteId/permission';
        endpoint = endpoint.replace(':siteId', siteIdFilter.value + "");
        return this.runGetQuery(endpoint, params);
    }
    createSitePermission(newSitePermission) {
        let endpoint = 'site/:siteId/permission';
        let self = this;
        endpoint = endpoint.replace(':siteId', (newSitePermission.siteId ? newSitePermission.siteId : '') + "");
        return this.runPostQuery(endpoint, newSitePermission.toServer(), false, null, false);
    }
    deleteSitePermission(sitePermissionId, item) {
        let endpoint = 'site/:siteId/permission';
        endpoint = endpoint.replace(':siteId', item.siteId + "");
        return this.runDeleteQuery(endpoint, sitePermissionId, false);
    }
    updateSitePermission(sitePermissionId, updateObj, item) {
        let endpoint = 'site/:siteId/permission';
        endpoint = endpoint.replace(':siteId', (item.siteId ? item.siteId : '') + "");
        return this.runPutQuery(endpoint + '/' + sitePermissionId, updateObj, false);
    }
    getApplianceCategorys(params) {
        let endpoint = 'applianceCategory';
        return this.runGetQuery(endpoint, params);
    }
    getApplianceTypes(params) {
        let endpoint = 'applianceType';
        return this.runGetQuery(endpoint, params);
    }
    getDataUploads(params) {
        let endpoint = 'data-upload';
        return this.runGetQuery(endpoint, params);
    }
    getDataUpload(params) {
        let endpoint = 'data-upload';
        return this.runSingleGetQuery(endpoint, params.id);
    }
    createDataUpload(newDataUpload, onUploadProgress) {
        let endpoint = 'data-upload';
        let self = this;
        return this.runPostQuery(endpoint, newDataUpload.toServer(), true, onUploadProgress, false);
    }
    deleteDataUpload(dataUploadId, item) {
        let endpoint = 'data-upload';
        return this.runDeleteQuery(endpoint, dataUploadId, false);
    }
    updateDataUpload(dataUploadId, updateObj, item) {
        let endpoint = 'data-upload';
        return this.runPutQuery(endpoint + '/' + dataUploadId, updateObj, false);
    }
    getFiles(params) {
        let itemTypeFilter = params.filters.find(f => f.field === 'itemType');
        let itemIdFilter = params.filters.find(f => f.field === 'itemId');
        if (!itemTypeFilter || !itemIdFilter) {
            return Promise.reject('Missing required parameter in filters');
        }
        let endpoint = 'upload/:itemType/:itemId';
        endpoint = endpoint.replace(':itemType', itemTypeFilter.value + "");
        endpoint = endpoint.replace(':itemId', itemIdFilter.value + "");
        return this.runGetQuery(endpoint, params);
    }
    createFile(newFile, onUploadProgress) {
        let endpoint = 'upload/:itemType/:itemId';
        let self = this;
        endpoint = endpoint.replace(':itemType', (newFile.itemType ? newFile.itemType : '') + "");
        endpoint = endpoint.replace(':itemId', (newFile.itemId ? newFile.itemId : '') + "");
        return this.runPostQuery(endpoint, newFile.toServer(), true, onUploadProgress, false);
    }
    deleteFile(fileId, item) {
        let endpoint = 'upload/:itemType/:itemId';
        endpoint = endpoint.replace(':itemType', item.itemType + "");
        endpoint = endpoint.replace(':itemId', item.itemId + "");
        return this.runDeleteQuery(endpoint, fileId, false);
    }
    updateFile(fileId, updateObj, item) {
        let endpoint = 'upload/:itemType/:itemId';
        endpoint = endpoint.replace(':itemType', (item.itemType ? item.itemType : '') + "");
        endpoint = endpoint.replace(':itemId', (item.itemId ? item.itemId : '') + "");
        return this.runPutQuery(endpoint + '/' + fileId, updateObj, false);
    }
    createZip(newZip) {
        let endpoint = 'upload/site/:siteId/zip';
        let self = this;
        endpoint = endpoint.replace(':siteId', (newZip.siteId ? newZip.siteId : '') + "");
        return this.runPostQuery(endpoint, newZip.toServer(), false, null, false);
    }
    getSearchs(params) {
        let queryFilter = params.filters.find(f => f.field === 'query');
        if (!queryFilter) {
            return Promise.reject('Missing required parameter in filters');
        }
        let endpoint = 'search';
        endpoint = endpoint.replace(':query', queryFilter.value + "");
        return this.runGetQuery(endpoint, params);
    }
    getVerifyOrgInvite(params) {
        let endpoint = 'organisation/invite/validate';
        return this.runSingleGetQuery(endpoint, params.id, true);
    }
    createConfirmOrgInvite(newConfirmOrgInvite) {
        let endpoint = 'organisation/invite/confirm';
        let self = this;
        return this.runPostQuery(endpoint, newConfirmOrgInvite.toServer(), false, null, true);
    }
    createDcCreateAccount(newDcCreateAccount) {
        let endpoint = 'dc-create-account';
        let self = this;
        return this.runPostQuery(endpoint, newDcCreateAccount.toServer(), false, null, true);
    }
    getDcSessions(params) {
        let endpoint = 'dc-session';
        return this.runGetQuery(endpoint, params);
    }
    getDcSession(params) {
        let endpoint = 'dc-session';
        return this.runSingleGetQuery(endpoint, params.id);
    }
    createDcSession(newDcSession) {
        let endpoint = 'dc-session';
        let self = this;
        return this.runPostQuery(endpoint, newDcSession.toServer(), false, null, false);
    }
    deleteDcSession(dcSessionId, item) {
        let endpoint = 'dc-session';
        return this.runDeleteQuery(endpoint, dcSessionId, false);
    }
    createPaymentSheet(newPaymentSheet) {
        let endpoint = 'payment-sheet';
        let self = this;
        return this.runPostQuery(endpoint, newPaymentSheet.toServer(), false, null, false);
    }
    getDcChargePoint(params) {
        let endpoint = 'dc-charge-point';
        return this.runSingleGetQuery(endpoint, params.id);
    }
    getDcChargeStations(params) {
        let endpoint = 'dc-charge-station';
        return this.runGetQuery(endpoint, params);
    }
    getOrganisationInvites(params) {
        let endpoint = 'orgInvite';
        return this.runGetQuery(endpoint, params);
    }
    createOrganisationInvite(newOrganisationInvite) {
        let endpoint = 'orgInvite';
        let self = this;
        return this.runPostQuery(endpoint, newOrganisationInvite.toServer(), false, null, false);
    }
    deleteOrganisationInvite(organisationInviteId, item) {
        let endpoint = 'orgInvite';
        return this.runDeleteQuery(endpoint, organisationInviteId, false);
    }
    updateOrganisationInvite(organisationInviteId, updateObj, item) {
        let endpoint = 'orgInvite';
        return this.runPutQuery(endpoint + '/' + organisationInviteId, updateObj, false);
    }
    getOrganisationMembers(params) {
        let endpoint = 'orgMember';
        return this.runGetQuery(endpoint, params);
    }
    deleteOrganisationMember(organisationMemberId, item) {
        let endpoint = 'orgMember';
        return this.runDeleteQuery(endpoint, organisationMemberId, false);
    }
    updateOrganisationMember(organisationMemberId, updateObj, item) {
        let endpoint = 'orgMember';
        return this.runPutQuery(endpoint + '/' + organisationMemberId, updateObj, false);
    }
    createOrganisationMemberLogout(organisationMemberId, newObject) {
        let endpoint = 'orgMember/:organisationMemberId/logout';
        endpoint = endpoint.replace(':organisationMemberId', organisationMemberId);
        return this.runPostQuery(endpoint, newObject, false, null, false);
    }
    getDetectedDevices(params) {
        let endpoint = 'potential_device';
        return this.runGetQuery(endpoint, params);
    }
    updateDetectedDevice(detectedDeviceId, updateObj, item) {
        let endpoint = 'potential_device';
        return this.runPutQuery(endpoint + '/' + detectedDeviceId, updateObj, false);
    }
    getResetToken(params) {
        let endpoint = 'account/reset_token';
        endpoint = endpoint.replace('/:token', '');
        return this.runSingleGetQuery(endpoint, params.id, true);
    }
    createResetToken(newResetToken) {
        let endpoint = 'account/reset_token';
        let self = this;
        endpoint = endpoint.replace(':token', (newResetToken.token ? newResetToken.token : '') + "");
        return this.runPostQuery(endpoint, newResetToken.toServer(), false, null, true);
    }
    updateResetToken(resetTokenId, updateObj, item) {
        let endpoint = 'account/reset_token';
        endpoint = endpoint.replace(':token', (item.token ? item.token : '') + "");
        return this.runPutQuery(endpoint + '/' + resetTokenId, updateObj, true);
    }
    createPassword(newPassword) {
        let endpoint = 'account/password';
        let self = this;
        return this.runPostQuery(endpoint, newPassword.toServer(), false, null, false);
    }
    getThirdPartyIntegrations(params) {
        let endpoint = 'third-party-integration';
        return this.runGetQuery(endpoint, params);
    }
    createThirdPartyIntegration(newThirdPartyIntegration) {
        let endpoint = 'third-party-integration';
        let self = this;
        return this.runPostQuery(endpoint, newThirdPartyIntegration.toServer(), false, null, false);
    }
    getOrgPartners(params) {
        let endpoint = 'org-partner';
        return this.runGetQuery(endpoint, params);
    }
    getOrgPartner(params) {
        let endpoint = 'org-partner';
        return this.runSingleGetQuery(endpoint, params.id);
    }
    createOrgPartner(newOrgPartner) {
        let endpoint = 'org-partner';
        let self = this;
        return this.runPostQuery(endpoint, newOrgPartner.toServer(), false, null, false);
    }
    deleteOrgPartner(orgPartnerId, item) {
        let endpoint = 'org-partner';
        return this.runDeleteQuery(endpoint, orgPartnerId, false);
    }
    updateOrgPartner(orgPartnerId, updateObj, item) {
        let endpoint = 'org-partner';
        return this.runPutQuery(endpoint + '/' + orgPartnerId, updateObj, false);
    }
    createMfaSecret(newMfaSecret) {
        let endpoint = 'account/mfa-secret';
        let self = this;
        return this.runPostQuery(endpoint, newMfaSecret.toServer(), false, null, false, true)
            .then(function (res) {
            self.accessTokenPromise = Promise.resolve();
            self.openSocket().then(function () {
                self.onLoggedInCallback.forEach(function (loggedInCallback) {
                    loggedInCallback();
                });
            });
            return Promise.resolve(res);
        });
    }
    createMfaVerification(newMfaVerification) {
        let endpoint = 'account/mfa-verification';
        let self = this;
        return this.runPostQuery(endpoint, newMfaVerification.toServer(), false, null, false, true)
            .then(function (res) {
            self.accessTokenPromise = Promise.resolve();
            self.openSocket().then(function () {
                self.onLoggedInCallback.forEach(function (loggedInCallback) {
                    loggedInCallback();
                });
            });
            return Promise.resolve(res);
        });
    }
    createMfaAuthentication(newMfaAuthentication) {
        let endpoint = 'account/mfa-authentication';
        let self = this;
        return this.runPostQuery(endpoint, newMfaAuthentication.toServer(), false, null, false, true)
            .then(function (res) {
            self.accessTokenPromise = Promise.resolve();
            self.openSocket().then(function () {
                self.onLoggedInCallback.forEach(function (loggedInCallback) {
                    loggedInCallback();
                });
            });
            return Promise.resolve(res);
        });
    }
    createLoginAs(newLoginAs) {
        let endpoint = 'login-as';
        let self = this;
        return this.runPostQuery(endpoint, newLoginAs.toServer(), false, null, false);
    }
    createLoginAsPartner(newLoginAsPartner) {
        let endpoint = 'login-as-partner';
        let self = this;
        return this.runPostQuery(endpoint, newLoginAsPartner.toServer(), false, null, false);
    }
    getOrganisationManagements(params) {
        let endpoint = 'organisation-management';
        return this.runGetQuery(endpoint, params);
    }
    getOrganisationManagement(params) {
        let endpoint = 'organisation-management';
        return this.runSingleGetQuery(endpoint, params.id);
    }
    updateOrganisationManagement(organisationManagementId, updateObj, item) {
        let endpoint = 'organisation-management';
        return this.runPutQuery(endpoint + '/' + organisationManagementId, updateObj, false);
    }
    getStagingDatabase(params) {
        let endpoint = 'staging-database';
        return this.runSingleGetQuery(endpoint, params.id);
    }
    updateStagingDatabase(stagingDatabaseId, updateObj, item) {
        let endpoint = 'staging-database';
        return this.runPutQuery(endpoint + '/' + stagingDatabaseId, updateObj, false);
    }
    getNotifications(params) {
        let endpoint = 'notification';
        return this.runGetQuery(endpoint, params);
    }
    updateNotification(notificationId, updateObj, item) {
        let endpoint = 'notification';
        return this.runPutQuery(endpoint + '/' + notificationId, updateObj, false);
    }
    getZigbeeFirmwares(params) {
        let endpoint = 'zigbee-firmware';
        return this.runGetQuery(endpoint, params);
    }
    getZigbeeFirmware(params) {
        let endpoint = 'zigbee-firmware';
        return this.runSingleGetQuery(endpoint, params.id);
    }
    getGatewayTrustList(params) {
        let endpoint = 'gateway-trust-list';
        return this.runSingleGetQuery(endpoint, params.id);
    }
    createGatewayTrustedDeviceUntrustRequest(newGatewayTrustedDeviceUntrustRequest) {
        let endpoint = 'gateway-trusted-device-untrust-request';
        let self = this;
        return this.runPostQuery(endpoint, newGatewayTrustedDeviceUntrustRequest.toServer(), false, null, false);
    }
    getTelemetryOperations(params) {
        let endpoint = 'telemetry-operation';
        return this.runGetQuery(endpoint, params);
    }
    createAggregateTelemetryGroupRequest(newAggregateTelemetryGroupRequest) {
        let endpoint = 'aggregate-telemetry-group-request';
        let self = this;
        return this.runPostQuery(endpoint, newAggregateTelemetryGroupRequest.toServer(), false, null, false);
    }
    createAssetRemoveDataRequest(newAssetRemoveDataRequest) {
        let endpoint = 'asset-remove-data-request';
        let self = this;
        return this.runPostQuery(endpoint, newAssetRemoveDataRequest.toServer(), false, null, false);
    }
    createAssetAggregateDataRequest(newAssetAggregateDataRequest) {
        let endpoint = 'asset-aggregate-data-request';
        let self = this;
        return this.runPostQuery(endpoint, newAssetAggregateDataRequest.toServer(), false, null, false);
    }
    getGatewayTrustedDeviceAnalysiss(params) {
        let endpoint = 'gateway-trusted-device-analysis';
        return this.runGetQuery(endpoint, params);
    }
    getGatewayTrustedDeviceAnalysis(params) {
        let endpoint = 'gateway-trusted-device-analysis';
        return this.runSingleGetQuery(endpoint, params.id);
    }
    createGatewayTrustedDeviceAnalysis(newGatewayTrustedDeviceAnalysis) {
        let endpoint = 'gateway-trusted-device-analysis';
        let self = this;
        return this.runPostQuery(endpoint, newGatewayTrustedDeviceAnalysis.toServer(), false, null, false);
    }
    deleteGatewayTrustedDeviceAnalysis(gatewayTrustedDeviceAnalysisId, item) {
        let endpoint = 'gateway-trusted-device-analysis';
        return this.runDeleteQuery(endpoint, gatewayTrustedDeviceAnalysisId, false);
    }
    updateGatewayTrustedDeviceAnalysis(gatewayTrustedDeviceAnalysisId, updateObj, item) {
        let endpoint = 'gateway-trusted-device-analysis';
        return this.runPutQuery(endpoint + '/' + gatewayTrustedDeviceAnalysisId, updateObj, false);
    }
    getAggregateTelemetrys(params) {
        let endpoint = 'telemetry/aggregate/:assetId/:dataType/:start/:end/:granularity';
        return this.runGetQuery(endpoint, params);
    }
    getAggregateTelemetry(params) {
        let endpoint = 'telemetry/aggregate/:assetId/:dataType/:start/:end/:granularity';
        return this.runSingleGetQuery(endpoint, params.id);
    }
    createAggregateTelemetry(newAggregateTelemetry) {
        let endpoint = 'telemetry/aggregate/:assetId/:dataType/:start/:end/:granularity';
        let self = this;
        return this.runPostQuery(endpoint, newAggregateTelemetry.toServer(), false, null, false);
    }
    deleteAggregateTelemetry(aggregateTelemetryId, item) {
        let endpoint = 'telemetry/aggregate/:assetId/:dataType/:start/:end/:granularity';
        return this.runDeleteQuery(endpoint, aggregateTelemetryId, false);
    }
    updateAggregateTelemetry(aggregateTelemetryId, updateObj, item) {
        let endpoint = 'telemetry/aggregate/:assetId/:dataType/:start/:end/:granularity';
        return this.runPutQuery(endpoint + '/' + aggregateTelemetryId, updateObj, false);
    }
    getInstantaneousTelemetrys(params) {
        let endpoint = 'telemetry/instantaneous/:assetId/:dataType/:start/:end/:granularity';
        return this.runGetQuery(endpoint, params);
    }
    getInstantaneousTelemetry(params) {
        let endpoint = 'telemetry/instantaneous/:assetId/:dataType/:start/:end/:granularity';
        return this.runSingleGetQuery(endpoint, params.id);
    }
    createInstantaneousTelemetry(newInstantaneousTelemetry) {
        let endpoint = 'telemetry/instantaneous/:assetId/:dataType/:start/:end/:granularity';
        let self = this;
        return this.runPostQuery(endpoint, newInstantaneousTelemetry.toServer(), false, null, false);
    }
    deleteInstantaneousTelemetry(instantaneousTelemetryId, item) {
        let endpoint = 'telemetry/instantaneous/:assetId/:dataType/:start/:end/:granularity';
        return this.runDeleteQuery(endpoint, instantaneousTelemetryId, false);
    }
    updateInstantaneousTelemetry(instantaneousTelemetryId, updateObj, item) {
        let endpoint = 'telemetry/instantaneous/:assetId/:dataType/:start/:end/:granularity';
        return this.runPutQuery(endpoint + '/' + instantaneousTelemetryId, updateObj, false);
    }
    getOrganisationSearchs(params) {
        let endpoint = 'organisation/search';
        return this.runGetQuery(endpoint, params);
    }
    createGatewayLogDownloadRequest(newGatewayLogDownloadRequest) {
        let endpoint = 'gateway-log-download-request';
        let self = this;
        return this.runPostQuery(endpoint, newGatewayLogDownloadRequest.toServer(), false, null, false);
    }
    createGatewayEnhancedLogDownloadRequest(newGatewayEnhancedLogDownloadRequest) {
        let endpoint = 'gateway-enhanced-log-download-request';
        let self = this;
        return this.runPostQuery(endpoint, newGatewayEnhancedLogDownloadRequest.toServer(), false, null, false);
    }
    getGatewayGods(params) {
        let endpoint = 'gateway-god';
        return this.runGetQuery(endpoint, params);
    }
    getGatewayGod(params) {
        let endpoint = 'gateway-god';
        return this.runSingleGetQuery(endpoint, params.id);
    }
    createGatewayGod(newGatewayGod) {
        let endpoint = 'gateway-god';
        let self = this;
        return this.runPostQuery(endpoint, newGatewayGod.toServer(), false, null, false);
    }
    deleteGatewayGod(gatewayGodId, item) {
        let endpoint = 'gateway-god';
        return this.runDeleteQuery(endpoint, gatewayGodId, false);
    }
    updateGatewayGod(gatewayGodId, updateObj, item) {
        let endpoint = 'gateway-god';
        return this.runPutQuery(endpoint + '/' + gatewayGodId, updateObj, false);
    }
    getAssetGods(params) {
        let endpoint = 'asset-god';
        return this.runGetQuery(endpoint, params);
    }
    getAssetGod(params) {
        let endpoint = 'asset-god';
        return this.runSingleGetQuery(endpoint, params.id);
    }
    createAssetGod(newAssetGod) {
        let endpoint = 'asset-god';
        let self = this;
        return this.runPostQuery(endpoint, newAssetGod.toServer(), false, null, false);
    }
    deleteAssetGod(assetGodId, item) {
        let endpoint = 'asset-god';
        return this.runDeleteQuery(endpoint, assetGodId, false);
    }
    updateAssetGod(assetGodId, updateObj, item) {
        let endpoint = 'asset-god';
        return this.runPutQuery(endpoint + '/' + assetGodId, updateObj, false);
    }
    getAssetTelemetryBatchs(params) {
        let dataTypeFilter = params.filters.find(f => f.field === 'dataType');
        let assetIdFilter = params.filters.find(f => f.field === 'assetId');
        let startFilter = params.filters.find(f => f.field === 'start');
        let endFilter = params.filters.find(f => f.field === 'end');
        if (!dataTypeFilter || !assetIdFilter || !startFilter || !endFilter) {
            return Promise.reject('Missing required parameter in filters');
        }
        let endpoint = 'assetTelemetryBatch/:dataType/:start/:end';
        endpoint = endpoint.replace(':dataType', dataTypeFilter.value + "");
        endpoint = endpoint.replace(':assetId', assetIdFilter.value + "");
        endpoint = endpoint.replace(':start', startFilter.value + "");
        endpoint = endpoint.replace(':end', endFilter.value + "");
        return this.runGetQuery(endpoint, params);
    }
    getAssetConsumptionBatchs(params) {
        let assetIdFilter = params.filters.find(f => f.field === 'assetId');
        let startFilter = params.filters.find(f => f.field === 'start');
        let endFilter = params.filters.find(f => f.field === 'end');
        let granularityFilter = params.filters.find(f => f.field === 'granularity');
        let dataTypeFilter = params.filters.find(f => f.field === 'dataType');
        if (!assetIdFilter || !startFilter || !endFilter || !granularityFilter || !dataTypeFilter) {
            return Promise.reject('Missing required parameter in filters');
        }
        let endpoint = 'telemetry/assetConsumptionBatch/:start/:end/:granularity';
        endpoint = endpoint.replace(':assetId', assetIdFilter.value + "");
        endpoint = endpoint.replace(':start', startFilter.value + "");
        endpoint = endpoint.replace(':end', endFilter.value + "");
        endpoint = endpoint.replace(':granularity', granularityFilter.value + "");
        endpoint = endpoint.replace(':dataType', dataTypeFilter.value + "");
        return this.runGetQuery(endpoint, params);
    }
    getRawAggregateDatas(params) {
        let assetIdFilter = params.filters.find(f => f.field === 'assetId');
        let startFilter = params.filters.find(f => f.field === 'start');
        let endFilter = params.filters.find(f => f.field === 'end');
        let dataTypeFilter = params.filters.find(f => f.field === 'dataType');
        if (!assetIdFilter || !startFilter || !endFilter || !dataTypeFilter) {
            return Promise.reject('Missing required parameter in filters');
        }
        let endpoint = 'raw-aggregate-data';
        endpoint = endpoint.replace(':assetId', assetIdFilter.value + "");
        endpoint = endpoint.replace(':start', startFilter.value + "");
        endpoint = endpoint.replace(':end', endFilter.value + "");
        endpoint = endpoint.replace(':dataType', dataTypeFilter.value + "");
        return this.runGetQuery(endpoint, params);
    }
    getAssetResets(params) {
        let assetIdFilter = params.filters.find(f => f.field === 'assetId');
        let startFilter = params.filters.find(f => f.field === 'start');
        let endFilter = params.filters.find(f => f.field === 'end');
        if (!assetIdFilter || !startFilter || !endFilter) {
            return Promise.reject('Missing required parameter in filters');
        }
        let endpoint = 'asset-reset';
        endpoint = endpoint.replace(':assetId', assetIdFilter.value + "");
        endpoint = endpoint.replace(':start', startFilter.value + "");
        endpoint = endpoint.replace(':end', endFilter.value + "");
        return this.runGetQuery(endpoint, params);
    }
    createAssetReset(newAssetReset) {
        let endpoint = 'asset-reset';
        let self = this;
        endpoint = endpoint.replace(':assetId', (newAssetReset.assetId ? newAssetReset.assetId : '') + "");
        endpoint = endpoint.replace(':start', (newAssetReset.start ? newAssetReset.start : '') + "");
        endpoint = endpoint.replace(':end', (newAssetReset.end ? newAssetReset.end : '') + "");
        return this.runPostQuery(endpoint, newAssetReset.toServer(), false, null, false);
    }
    deleteAssetReset(assetResetId, item) {
        let endpoint = 'asset-reset';
        endpoint = endpoint.replace(':assetId', item.assetId + "");
        endpoint = endpoint.replace(':start', item.start + "");
        endpoint = endpoint.replace(':end', item.end + "");
        return this.runDeleteQuery(endpoint, assetResetId, false);
    }
    updateAssetReset(assetResetId, updateObj, item) {
        let endpoint = 'asset-reset';
        endpoint = endpoint.replace(':assetId', (item.assetId ? item.assetId : '') + "");
        endpoint = endpoint.replace(':start', (item.start ? item.start : '') + "");
        endpoint = endpoint.replace(':end', (item.end ? item.end : '') + "");
        return this.runPutQuery(endpoint + '/' + assetResetId, updateObj, false);
    }
    getEnergyMasterTests(params) {
        let endpoint = 'energy-master-test';
        return this.runGetQuery(endpoint, params, true);
    }
    createEnergyMasterTest(newEnergyMasterTest) {
        let endpoint = 'energy-master-test';
        let self = this;
        return this.runPostQuery(endpoint, newEnergyMasterTest.toServer(), false, null, true);
    }
    createInspiredLogin(newInspiredLogin) {
        let endpoint = 'inspired-login';
        let self = this;
        return this.runPostQuery(endpoint, newInspiredLogin.toServer(), false, null, true);
    }
    getDataUnits(params) {
        let endpoint = 'data-unit';
        return this.runGetQuery(endpoint, params);
    }
    getDataUnit(params) {
        let endpoint = 'data-unit';
        return this.runSingleGetQuery(endpoint, params.id);
    }
    createDataUnit(newDataUnit) {
        let endpoint = 'data-unit';
        let self = this;
        return this.runPostQuery(endpoint, newDataUnit.toServer(), false, null, false);
    }
    deleteDataUnit(dataUnitId, item) {
        let endpoint = 'data-unit';
        return this.runDeleteQuery(endpoint, dataUnitId, false);
    }
    updateDataUnit(dataUnitId, updateObj, item) {
        let endpoint = 'data-unit';
        return this.runPutQuery(endpoint + '/' + dataUnitId, updateObj, false);
    }
    getItemMetadata(params) {
        let endpoint = 'item-metadata';
        return this.runSingleGetQuery(endpoint, params.id);
    }
}
exports.default = ApiService;
//# sourceMappingURL=api-service.js.map